<template>

	<div id="footer-bar" class="footer-bar-1 footer-bar-5">
		<router-link to="/" active-class="active-nav" exact><i class="fa fa-home"></i><span>صفحه اصلی</span><strong></strong></router-link>
		<!--<router-link to="/TaskCloseRequestList" active-class="active-nav"><i class="fa fa-folder-open"></i><span>کارتابل</span><strong></strong></router-link>-->
		<router-link to="/TaskList" active-class="active-nav" v-if="TaskAccess=='1'"><i class="far fa-check-square"></i><span>{{lableText('TasksName')??'وظایف'}}</span><strong></strong></router-link>
		<router-link to="/OtherWorkList" active-class="active-nav"><i class="far fa-list-alt"></i><span>فعالیت ها</span><strong></strong></router-link>
		<router-link to="/CheckList" active-class="active-nav"><i class="far fa-sticky-note"></i><span>چک لیست</span><strong></strong></router-link>
		<router-link to="/PinList" active-class="active-nav"><i class="fas fa-thumbtack"></i><span>نشان شده ها</span><strong></strong></router-link>
		<router-link to="/LandingPage" active-class="active-nav"><i class="fa fa-th-large"></i><span>بیشتر</span><em class="badge bg-red1-dark" v-if="NotificationCount>0">*</em><strong></strong></router-link>
	</div>
</template>

<script>
    export default {
        computed: {
          
            NotificationCount() {
                return this.$store.getters.GetNotificationCount;
			},
           TaskAccess() {
                return this.$store.getters.GetTaskAccess;
            },
        },
        methods: {
            GetNotifCount() {
                this.$store.dispatch("GetNotificationCountFromServer");
            },
             GetAccesses() {
                this.$store.dispatch("GetTaskAccess");
            },
          
        },
        created() {
            this.GetNotifCount();
            this.GetAccesses();
        }
    };
</script>

